import { __module as r } from "./index777.js";
var i = r.exports, n;
function p() {
  return n ? r.exports : (n = 1, (function(u, s) {
    (function(f, t) {
      u.exports = t();
    })(i, (function() {
      return function(f, t, e) {
        t.prototype.dayOfYear = function(a) {
          var o = Math.round((e(this).startOf("day") - e(this).startOf("year")) / 864e5) + 1;
          return a == null ? o : this.add(a - o, "day");
        };
      };
    }));
  })(r), r.exports);
}
export {
  p as __require
};
